import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import AssessmentPortal from './pages/AssessmentPortal/AssessmentPortal';
import CreateAssessmentPage from './pages/CreateAssessmentPage/CreateAssessmentPage';

import ProvideUserContext from './contexts/UserContext';
import ProvideClientContext from './contexts/ClientContext';
import StaffPortal from './pages/StaffPortal';
import DocumentViewer from './pages/DocumentViewer';
import Maintenance from './pages/Maintenance/Maintenance';

const maintenanceMode = false;

export default function createRoutes() {
  if (maintenanceMode) {
    return (
      <ProvideUserContext>
        <ProvideClientContext>
          <Router>
            <Routes>
              <Route path="*" element={<Maintenance />} />
            </Routes>
          </Router>
        </ProvideClientContext>
      </ProvideUserContext>
    );
  }

  return (
    <ProvideUserContext>
      <ProvideClientContext>
        <Router>
          <Routes>
            <Route path="assessment/:bundleKey" element={<AssessmentPortal />} />
            <Route
              path="mod/"
              element={(
                <StaffPortal />
              )}
            />
            <Route path="mod/createassessment" element={<CreateAssessmentPage />} />
            <Route path="document/:signatureRequestId" element={<DocumentViewer />} />
          </Routes>
        </Router>
      </ProvideClientContext>
    </ProvideUserContext>
  );
}
